import React from 'react';
import {AnimatedEllipsis} from "../../components";
import { Context } from '../../context/dataStore';
import OrgDetail from './OrgDetail';

const ExpandedTableRow = ({orgId}) => {
  const { findorganswersbyorgidlasthed } = React.useContext(Context);

  const [response, setResponse] = React.useState(null);

  React.useEffect(() => {

    const fetchOrgDetail = async () => {
    if(orgId) {
      setResponse(null);
      const res = await findorganswersbyorgidlasthed(orgId);
      setResponse(res.data);
    }}
    fetchOrgDetail();

  }, [orgId]);

  return (
    <div>
      {!response && <div className='centerEllipsis'><AnimatedEllipsis /></div>}
      {response && <OrgDetail orgDetail={response} />}
    </div>
  );
}

export default ExpandedTableRow;
